import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Gift, Zap, MessageCircle, Home } from 'lucide-react';
const bonuses = [{
  icon: Zap,
  title: 'Cómo frenar una pelea en 60 segundos',
  desc: 'Técnicas rápidas y efectivas para desactivar una discusión antes de que escale y cause daño real.',
  value: '$4.900',
  img: 'https://cdn.magicpatterns.com/uploads/nzybojKY5VqVxTxgAJJdKG/Bonus_1.png'
}, {
  icon: MessageCircle,
  title: '50 Preguntas para volver a conocernos',
  desc: 'Preguntas profundas y reveladoras para reconectarse, redescubrirse y reavivar la curiosidad por el otro.',
  value: '$3.500',
  img: 'https://cdn.magicpatterns.com/uploads/117k2QL9vuB8ysdBw3Dv5B/Bonus_2.png'
}, {
  icon: Home,
  title: 'El Mapa de Nuestra Casa',
  desc: 'Acuerdos claros para una convivencia tranquila. Reglas de juego que eliminan el 80% de las peleas cotidianas.',
  value: '$2.500',
  img: 'https://cdn.magicpatterns.com/uploads/r3EThU7NP3yCpnGv296KpT/Bonus_3.png'
}];
export function BonusSection() {
  return <Section background="primary" data-id="element-13">
      <div className="text-center mb-16" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-5 py-2 mb-6 bg-[#E07AF0]/10 border border-[#E07AF0]/30 text-[#E07AF0] text-sm font-bold tracking-widest uppercase rounded-full" data-id="element-15">
          <Gift size={16} data-id="element-16" />
          Bonus incluidos gratis
        </motion.div>

        <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-17">
          Además del manual, te llevás{' '}
          <span className="text-[#E07AF0] italic" data-id="element-18">3 bonus exclusivos</span>
        </h2>
        <p className="text-[#9090B0] text-lg max-w-2xl mx-auto" data-id="element-19">
          Herramientas extra para acelerar tu transformación — incluidas sin
          costo adicional.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12" data-id="element-20">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-[#151535] border border-[#2A2A50] rounded-xl overflow-hidden" data-id="element-21">
            <div className="bg-[#E07AF0]/10 border-b border-[#2A2A50] px-6 py-3 flex items-center justify-between" data-id="element-22">
              <span className="text-[#E07AF0] text-xs font-bold uppercase tracking-wider" data-id="element-23">
                Bonus {index + 1}
              </span>
              <span className="text-[#9090B0] text-xs line-through" data-id="element-24">
                Valor: {bonus.value}
              </span>
            </div>
            <div className="p-4" data-id="element-25">
              <img src={bonus.img} alt={bonus.title} className="w-full rounded-lg mb-4" data-id="element-26" />
              <h3 className="text-lg font-serif font-bold text-white mb-3" data-id="element-27">
                {bonus.title}
              </h3>
              <p className="text-[#9090B0] text-sm leading-relaxed" data-id="element-28">
                {bonus.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center" data-id="element-29">
        <div className="bg-[#151535] border border-[#E07AF0]/20 rounded-2xl p-8 max-w-2xl mx-auto mb-8" data-id="element-30">
          <p className="text-[#9090B0] text-sm mb-2" data-id="element-31">
            Manual + 3 Bonus — Todo junto por:
          </p>
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-32">
            <span className="text-xl text-[#9090B0] line-through" data-id="element-33">$20.800</span>
            <span className="text-4xl font-bold text-white" data-id="element-34">
              $9.900{' '}
              <span className="text-lg text-[#9090B0] font-normal" data-id="element-35">ARS</span>
            </span>
          </div>
          <p className="text-[#E07AF0] text-sm font-medium" data-id="element-36">
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </div>

        <Button size="lg" icon href="https://www.mujerdigital2.com/cart/PLACEHOLDER:1" data-id="element-37">
          QUIERO TODO AHORA
        </Button>
      </motion.div>
    </Section>;
}